module.exports = __webpack_public_path__ + "6b9e2f63a221ad4312888caea61a296d.png";